import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const WarningLabel = styled.span`
    color: ${tokens.error.default};
`;

export function WarningText({
    text = 'This action cannot be undone.',
}: {
    /**
     * The text for the warning (defaults to 'This action cannot be undone.').
     */
    text?: string;
}) {
    return (
        <div className="py-10" data-cy="delete-component-modal-content">
            <WarningLabel className="warning-text bold">Warning! </WarningLabel>
            <span className="warning-text bold"> {text} </span>
        </div>
    );
}
